import { NodeType } from '@reach/interfaces/nodes/node-type.enum';

import { WorkspaceId } from '~app-client/workspaces/types';

export enum MenuPageSpecialKey {
	NODE_TYPE_SELECTOR = 'SELECTOR',
}

export enum CreationEntity {
	WORKSPACE = 'WORKSPACE',
}

export type CreationEntityKey = NodeType | MenuPageSpecialKey | CreationEntity;

export type MenuPageKey = CreationEntityKey;

export enum WebsiteTypes {
	SITEMAP = 'SITEMAP',
	WEBSITE = 'WEBSITE',
	WEBSITE_SUBPAGES = 'WEBSITE_SUBPAGES',
}

export interface NodeCreationDataByKey {
	[CreationEntity.WORKSPACE]: {
		emoji: string;
		name: string;
	};
	[NodeType.WEBSITE]: {
		url?: string;
		option: WebsiteTypes;
	};
	[NodeType.TAG]: {
		option: string;
		name: string;
	};
	[NodeType.FILE]: {
		files: File[];
	};
}

export type NodeCreationData<T extends MenuPageKey | null> = T extends keyof NodeCreationDataByKey
	? NodeCreationDataByKey[T]
	: null;

export interface NodeCreationState<KEY extends MenuPageKey | null = MenuPageKey> {
	key: KEY;
	validForm?: boolean;
	data: KEY extends MenuPageKey ? NodeCreationData<KEY> | null : null;
	workspacesIds: WorkspaceId[] | null;
	fromFirstAction: boolean;
	fromShare: boolean;
}
